import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { DefaultMapEntity } from '../../../map/types';
import { useDispatch } from 'react-redux';
import { setSelectedCompound } from '../../../../redux/slices/mapSlice';

const LocationOnMap = ({ mapData }: { mapData: DefaultMapEntity }) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const dispatch = useDispatch();
  const handleMapRedirect = () => {
    dispatch(setSelectedCompound(mapData));
    router.push(`/search?view=map`);
  };

  return (
    <Container>
      <h3 className="headline">{t('location_on_map')}</h3>
      <div className="image-container" onClick={handleMapRedirect}>
        <ImageWrapper
          src={`/assets/images/common/modon-map-banner${router.locale == 'ar' ? '-ar' : ''}.png`}
          alt={t('location_on_map')}
          fill
          style={{ borderRadius: '18px', objectFit: 'cover' }}
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  .image-container {
    width: 100%;
    height: 128px;
    position: relative;
    cursor: pointer;

    .expand-icon {
      position: absolute;
      border-radius: 200px;
      background: rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      top: 16px;
      inset-inline-end: 16px;
      width: 30px;
      height: 30px;
    }
  }
`;

export default LocationOnMap;
